export default __webpack_public_path__ + "static/media/age-icon.228a347d.svg";